import "./App.css";
import MainPage from "./MainPage";
import { HashRouter, Route, Routes } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import bg from "./Media/background-3.png";
import Footer from "./Footer";
// import RamadanSchedule from "./RamadanSchedule";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: "Sitka Text",
    },
  });
  return (
    <div style={{ backgroundImage: `url(${bg})` }}>
      <HashRouter>
        <ThemeProvider theme={theme}>
          <Routes>
            <Route path="/" element={<MainPage />} />
            {/*  <Route path="/ramadanSchedule" element={<RamadanSchedule />} /> */}
          </Routes>
          <Footer />
        </ThemeProvider>
      </HashRouter>
    </div>
  );
}

export default App;
